<template>
  <div>
    <div class="promo-design-inputs">
      <v-expansion-panels
        v-if="
          !actionGroup &&
          !model.experiment &&
          model.path_type !== PromptTypes.scheduled_push.value &&
          !isNewDeviceInterstitial
        "
        v-model="getTopPanel"
        multiple
        focusable
      >
        <v-expansion-panel>
          <v-expansion-panel-title>Localization</v-expansion-panel-title>
          <v-expansion-panel-text class="retention-config-segments">
            <v-radio-group v-model="model.filter.is_translated" density="compact" class="mt-6">
              <v-radio label="Localized" :value="true"></v-radio>
              <v-radio label="Not Localized" class="mt-1" :value="false"></v-radio>
            </v-radio-group>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel v-if="isLocalized">
          <v-expansion-panel-title>Languages</v-expansion-panel-title>
          <v-expansion-panel-text>
            <RfPromoLanguages
              :model="model"
              :actionGroup="actionGroup"
              :viewTypeTab="viewTypeTab"
              :actions="actions"
              @forceParentRender="forceParentRender"
            />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <template v-if="isModalOrVideo && canConfigure">
        <v-expansion-panels
          v-if="viewTypeTab === 'desktopViewTab'"
          v-model="getPromoPanel"
          multiple
          focusable
        >
          <v-expansion-panel>
            <v-expansion-panel-title>Message</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>
              <span>Size</span>
            </v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionWindowSize
                :model="model"
                :actions="actions"
                :showPopUpSize="isNewDeviceEditor"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionButtons :actions="actions" :model="model" showCloseOptions />
              <RfRetentionBehavior
                :model="model"
                :actions="actions"
                :showCloseOptions="false"
                :clickOutsideSupported="true"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="surveyFormSupported">
            <v-expansion-panel-title>Form</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionFieldSet :model="model" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.device_type === 'web' && !isBanner">
            <v-expansion-panel-title>Consent Checkbox</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionConsent :model="model" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.device_type === 'web'">
            <v-expansion-panel-title>Countdown Timer</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsCountdown :model="model" :actions="actions" :app="app" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>Close Timer</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsBehavior
                :model="model"
                :actions="actions"
                :hideAutoCloseText="isNewDeviceEditor"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.path_type !== 'video'">
            <v-expansion-panel-title>Background</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionImageUpload
                :actions="actions"
                :model="model"
                @forceParentRender="forceParentRender"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.path_type === 'video'">
            <v-expansion-panel-title>Video</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionVideoUpload :model="model" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="!legalExcludeDevices && model.path_type !== 'video'">
            <v-expansion-panel-title>Legal</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsLinks :model="model" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>Effect</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfBorderEffects
                :actions="actions"
                :transparency="!isMobileAndTvAppAndAndroidAndCustomDevices"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>CSS</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <div class="promo-design-group">
                <RfPromoCustomCSS :actions="actions" />
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.device_type === 'web' && app.flags.paywalls">
            <v-expansion-panel-title>Paywall</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfPaywallConfig :actions="actions" :model="model" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="inApp">
            <v-expansion-panel-title>In-App Purchase</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsInapp
                :actions="actions"
                :app="app"
                :deviceType="model.device_type"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.device_type !== 'web'">
            <v-expansion-panel-title>Deep Link</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsDeeplink :deviceType="model.device_type" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsMetadata :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-expansion-panels
          v-if="viewTypeTab === 'mobilewebViewTab'"
          v-model="getPromoPanel"
          multiple
          focusable
        >
          <v-expansion-panel>
            <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="isNewDeviceEditor">
            <v-expansion-panel-title>
              <span>Size</span>
            </v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionWindowSize :model="model" :actions="actions" showPopUpSize />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.path_type === 'video'">
            <v-expansion-panel-title>Video</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfRetentionVideoUpload
                v-if="model.device_type === 'web' && model.path_type === 'video'"
                :model="model"
                :actions="actions"
                :isMobile="true"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>Effect</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfBorderEffects :actions="actions" mobile />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title>CSS</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfPromoCustomCSS :actions="actions" />
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel v-if="model.device_type === 'web' && app.flags.paywalls">
            <v-expansion-panel-title>Paywall</v-expansion-panel-title>
            <v-expansion-panel-text class="retention-config-segments">
              <RfPaywallConfig :actions="actions" :model="model" />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </div>
    <RfRetentionActionsWidget
      v-if="isWidget && canConfigure"
      :model="model"
      :actions="actions"
      :app="app"
      :viewTypeTab="viewTypeTab"
      @forceParentRender="forceParentRender"
    />
    <RfRetentionActionsBanner
      v-if="isBanner && canConfigure"
      :model="model"
      :actions="actions"
      :app="app"
      :viewTypeTab="viewTypeTab"
      @updateBannerPosition="p => (actions.rf_widget_position = p)"
      @updateMobileBannerPosition="p => (actions.rf_mobile_widget_position = p)"
    />
    <RfRetentionActionsInterstitial
      v-if="isInterstitial && canConfigure"
      :model="model"
      :actions="actions"
      :app="app"
      :viewTypeTab="viewTypeTab"
      @forceParentRender="forceParentRender"
    />
    <RfRetentionActionsInlinePromo
      v-if="isHorizontalVerticalTile && canConfigure"
      :model="model"
      :actions="actions"
      :app="app"
      :viewTypeTab="viewTypeTab"
      @forceParentRender="forceParentRender"
    />
    <RfRetentionActionsTextPromo
      v-if="model.path_type === 'text' && canConfigure"
      :model="model"
      :actions="actions"
      :app="app"
      :viewTypeTab="viewTypeTab"
    />
    <RfRetentionActionsEmailPromo
      v-if="isEmail(model)"
      :model="model"
      :actions="actions"
      :app="app"
    />
    <RfRetentionActionsPushPromo
      v-if="isPushNotification(model)"
      :model="model"
      :actions="actions"
      :app="app"
    />
  </div>
</template>

<script>
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfPromoLanguages from "@/components/RfPromotions/RfPromoLanguages.vue";
import RfRetentionActionsBanner from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBanner.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import RfRetentionActionsDeeplink from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsDeeplink.vue";
import RfRetentionActionsEmailPromo from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsEmailPromo.vue";
import RfRetentionActionsInapp from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInapp.vue";
import RfRetentionActionsInlinePromo from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInlinePromo.vue";
import RfRetentionActionsInterstitial from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInterstitial.vue";
import RfRetentionActionsLinks from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsLinks.vue";
import RfRetentionActionsMetadata from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMetadata.vue";
import RfRetentionActionsCountdown from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsCountdown.vue";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfRetentionActionsTextPromo from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTextPromo.vue";
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsWidget from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsWidget.vue";
import RfRetentionBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionBehavior.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionFieldSet from "@/components/RfPathCreate/RfRetentionActions/RfRetentionFieldSet.vue";
import RfRetentionConsent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionConsent.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import RfRetentionVideoUpload from "@/components/RfPathCreate/RfRetentionActions/RfRetentionVideoUpload.vue";
import RfRetentionWindowSize from "@/components/RfPathCreate/RfRetentionActions/RfRetentionWindowSize.vue";
import { cloneDeep } from "lodash-es";
import { isEmail, isPushNotification, hasInapp } from "@/utils/prompts/promptHelpers";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";
import { DefaultDeviceOptions, DeviceTypeWording } from "@/utils/constants/DevicesConstants";
import { useAppsStore } from "@/pinia/appsStore";
import { computed } from "vue";
import RfBorderEffects from "./RfBorderEffects.vue";
import RfRetentionActionsPushPromo from "./RfRetentionActionsPushPromo.vue";
import RfPaywallConfig from "./RfPaywallConfig.vue";

export default {
  name: "RfRetentionActionsInputs",
  components: {
    RfPromoCustomCSS,
    RfPromoLanguages,
    RfRetentionActionsBanner,
    RfRetentionActionsBehavior,
    RfRetentionActionsDeeplink,
    RfRetentionActionsEmailPromo,
    RfRetentionActionsInapp,
    RfRetentionActionsInlinePromo,
    RfRetentionActionsInterstitial,
    RfRetentionActionsLinks,
    RfRetentionActionsMetadata,
    RfRetentionActionsMobileWeb,
    RfRetentionActionsTextPromo,
    RfRetentionActionsTitleMessage,
    RfRetentionActionsWidget,
    RfRetentionBehavior,
    RfRetentionButtons,
    RfRetentionFieldSet,
    RfRetentionConsent,
    RfRetentionImageUpload,
    RfRetentionVideoUpload,
    RfRetentionWindowSize,
    RfRetentionActionsPushPromo,
    RfRetentionActionsCountdown,
    RfBorderEffects,
    RfPaywallConfig,
  },
  mixins: [LanguagePreviewMixin],
  props: ["actions", "model", "viewTypeTab", "actionGroup"],
  setup: () => {
    const appsStore = useAppsStore();
    return {
      isEmail,
      isPushNotification,
      PromptTypes,
      app: computed(() => cloneDeep(appsStore.app)),
    };
  },
  data() {
    return {
      getPromoPanel: [0],
      getTopPanel: [0],
    };
  },
  computed: {
    isNewApple() {
      return (
        !this.app?.flags?.legacy_apple_editor &&
        [DefaultDeviceOptions.tv_os.value, DefaultDeviceOptions.ios.value].includes(
          this.model.device_type,
        )
      );
    },
    isNewAndroid() {
      return (
        this.app?.flags?.new_android_editor &&
        (this.model.device_type === DefaultDeviceOptions.android_os.value ||
          this.model.device_type === DefaultDeviceOptions.android_tv.value)
      );
    },
    isNewDeviceInterstitial() {
      return (
        ["android_os", "android_tv", "ios"].includes(this.model.device_type) &&
        this.model.path_type === "interstitial"
      );
    },
    isNewDeviceEditor() {
      return this.isNewAndroid || this.isNewApple;
    },
    inApp() {
      return (
        hasInapp(this.model) ||
        (this.model.path_type === PromptTypes.retention_modal.value &&
          this.model.device_type === DefaultDeviceOptions.tv_os.value)
      );
    },
    isTVapp() {
      const devices = [
        DeviceTypeWording.roku_os.value,
        DeviceTypeWording.tv_os.value,
        DeviceTypeWording.android_os.value,
        DeviceTypeWording.android_tv.value,
        DeviceTypeWording.custom_defined.value,
      ];
      return devices.includes(this.model.device_type);
    },
    legalExcludeDevices() {
      return (
        this.isMobileAndTvAppAndAndroid &&
        ![DeviceTypeWording.ios.value, DeviceTypeWording.android_os.value].includes(
          this.model.device_type,
        )
      );
    },
    isMobileAndTvAppAndAndroid() {
      const devices = [
        DeviceTypeWording.roku_os.value,
        DeviceTypeWording.tv_os.value,
        DeviceTypeWording.ios.value,
        DeviceTypeWording.android_tv.value,
      ];
      if (this.app?.flags?.new_android_editor) devices.push(DeviceTypeWording.android_os.value);
      return devices.includes(this.model.device_type);
    },
    isMobileAndTvAppAndAndroidAndCustomDevices() {
      return (
        this.isMobileAndTvAppAndAndroid ||
        this.model.device_type === DeviceTypeWording.custom_defined.value
      );
    },
    surveyFormSupported() {
      return [
        DefaultDeviceOptions.web.value,
        DefaultDeviceOptions.ios.value,
        DefaultDeviceOptions.tv_os.value,
        DefaultDeviceOptions.android_os.value,
        DefaultDeviceOptions.android_tv.value,
        DefaultDeviceOptions.roku_os.value,
      ].includes(this.model.device_type);
    },
    isModalOrVideo() {
      const pathType = this.model.path_type;
      return pathType === "retention_modal" || pathType === "video";
    },
    isInterstitial() {
      return this.model.path_type === "interstitial";
    },
    isWidget() {
      return this.model.path_type === "widget";
    },
    isBanner() {
      return this.model.path_type === "bottom_banner";
    },
    isHorizontalVerticalTile() {
      const pathType = this.model.path_type;
      return pathType === "horizontal" || pathType === "vertical" || pathType === "tile";
    },
    imageSizeHelpText() {
      if (this.isTVapp) return "16:9 image, 1920 x 1080 px recommended";
      return "2400 x 1600 px recommended";
    },
  },
  methods: {
    forceParentRender() {
      this.$emit("forceRender");
    },
  },
};
</script>
